// Import the functions you need from the SDKs you need
import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, initializeFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics, isSupported } from "firebase/analytics";
import { isBrowser } from "../utils/environment";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
let firebase_app =
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// Initialize Firestore with persistence
export const db = isBrowser
  ? initializeFirestore(firebase_app, {
      cache: {
        tabManager: {
          // Enable multi-tab persistence
          persistenceEnabled: true,
          // Optional: Specify how many tabs can have persistence enabled
          maxConcurrentTabs: 5,
        },
      },
    })
  : getFirestore(firebase_app);

export const auth = getAuth(firebase_app);
export default firebase_app;

export const storage = getStorage(firebase_app);

// Initialize Analytics only in browser and if supported
export const analytics = isBrowser
  ? isSupported().then(() => getAnalytics(firebase_app))
  : null;
